<template>
  <v-container fluid>
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="filteredAllBadges"
      @onSearch="viewState.state.filters.searchText = $event"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      @removeAllFilters="removeAllFilters"
      :emptyObjectData="emptyObjectData"
      @levelCounterFilter="levelCounterFilter"
      @onClickBreadcrumb="onClickBreadcrumb"
    >
    </UniversalTable>
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee Readiness"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="[]"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
  </v-container>
</template>

<script setup>
import { computed, watch, ref, defineProps } from "vue";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "./composables/useTableConfig";
import { useViewState } from "./composables/useViewState";
import { useEmployeeDirectoryViewState } from "../EmployeeDirectory/composables/useViewState";
import SearchModal from "@components/SearchBar/SearchModal.vue";

const tableConfig = useTableConfig();
const viewState = useViewState();
const viewEmployeeDirectoryViewState = useEmployeeDirectoryViewState();
const levelFilter = ref([]);
const emptyObjectData = {
  singular: "Badge",
  plural: "Badges",
};
const props = defineProps({
  dataSource: {
    type: Array,
    default: () => [],
  },
});
const badgeOrder = ["Master", "Coach", "Professional", "Apprentice"];
const filteredAllBadges = computed(() => {
  let allBadges = props?.dataSource || [];

  if (
    viewState.state.filters.searchText &&
    viewState.state.filters.searchText.length > 0
  ) {
    const searchText = viewState.state.filters.searchText.toLowerCase();

    allBadges = allBadges.filter((el) => {
      const fullName = `${el.name} ${el.code}`.toLowerCase();
      return (
        fullName.includes(searchText) ||
        el.name.toLowerCase().includes(searchText)
      );
    });
  }
  if (levelFilter.value.length > 0) {
    allBadges = allBadges.filter((item) =>
      levelFilter.value.includes(item.badge.level)
    );
  }

  allBadges = allBadges.sort((a, b) => {
    return (
      badgeOrder.indexOf(a.badge.level) - badgeOrder.indexOf(b.badge.level)
    );
  });
  return allBadges;
});
const levelCounter = computed(() => {
  return filteredAllBadges?.value.reduce((acc, item) => {
    const level = item.badge.level.toLowerCase();
    acc[level] = (acc[level] || 0) + 1;
    return acc;
  }, {});
});

watch(
  levelCounter,
  (newVal) => {
    tableConfig.tableParams.value.levelCounter = newVal;
  },
  { immediate: true, deep: true }
);
const levelCounterFilter = (event) => {
  levelFilter.value = event;
  tableConfig.tableParams.value.levelFilterCounter = event;
};
const onClickBreadcrumb = (breadcrumb) => {
  if (breadcrumb) {
    viewEmployeeDirectoryViewState.state.showEmployeeBadgesList = false;
  }
};
const removeAllFilters = () => {
  viewState.state.filters.searchText = "";
  levelFilter.value = [];
  tableConfig.tableParams.value.levelFilterCounter = [];
};
</script>

<style scoped>
.icon-container {
  cursor: pointer;
}
::v-deep(.ex-proficiency-badge > span) {
  min-width: 100px !important;
  text-align: center !important;
  justify-content: center !important;
}
</style>
